import styled from 'styled-components';

export const EducationList = styled.ul`
    & li {
        padding-left: 0.7rem;
        margin-top: 1.0rem;
        font-size: 0.9rem;

        border-left: 1px solid #3a7bd5;
    }

    & li h2 {
        font-size: 1.3rem;
        font-weight: 700;
        line-height: 170%;
    }

    & li p {
        line-height: 170%;
    }
`;